import store from '@/store';
const THREE = window.THREE;
import { toPoint2D, isLeft } from './threejsUtils'
import { ForgeAppearanceOptions, ForgeObject } from './../scripts/js/forgeModels';
import { takeScreenshot, ForgeVisiblityMode } from '../scripts/js/forgeService';
import HttpService from './httpService';
const Autodesk = window.Autodesk;

//https://adndevblog.typepad.com/cloud_and_mobile/2015/08/getting-bounding-boxes-of-each-component-in-the-viewer.html
export function getModifiedWorldBoundingBox(fragIds, model) {
    if (!model)
        model = store.state.viewer.model;

    //fragments list array
    var fragList = model.getFragmentList();
    const fragbBox = new THREE.Box3()
    const nodebBox = new THREE.Box3()

    fragIds.forEach(function (fragId) {
        fragList.getWorldBounds(fragId, fragbBox)
        nodebBox.union(fragbBox)
    })

    return nodebBox
}
export function getFragIdFromDbId(dbids, model = null) {
    if (!model)
        model = store.state.viewer.model;
    var returnValue = [];
    var it = model.getInstanceTree();
    for (const dbid of dbids) {
        it.enumNodeFragments(dbid, function (fragId) {
            returnValue.push(fragId);
        }, false);
    }
    return returnValue;
}
export function getBBBox(dbIds, model = null) {
    if (!model) model = store.state.viewer.model;

    let primitives = [];

    let tree = model.getInstanceTree();

    if (!tree) {
        store.dispatch({
            type: "alert_Forge",
            message: 'Model not fully loaded yet.'
        });
        
        return [];
    }

    dbIds.forEach(dbId => {
        tree.enumNodeChildren(dbId, child => {
            primitives.push(child)
        }, true)
    })

    let frags = getFragIdFromDbId(primitives);

    if (!frags.length) console.log(`Failed to get the center for IDs:: ${dbIds.join(',')}`);

    return getModifiedWorldBoundingBox(frags, model);
}
/**
 * This function is used to get the world bounding box of the array's center primitive element of the dbIds primitive children.
 * We use this function mainly to get << a Tag Point >> on the center of one of its primitive children.
 * Previously we used the getBBox function BUT it returns the world bounding box for the children, which is often far away from the dbIds children.
 * @param {dbIds} dbIds 
 * @param {model} model 
 * @returns world bounding box.
 */
export function getMiddleBBoxForGroup(dbIds, model = null) {
    if (!model) model = store.state.viewer.model;

    var tree = model.getInstanceTree();

    let primitives = [];

    // Get primitive children for dbIds
    dbIds.forEach(dbId => {
        tree.enumNodeChildren(dbId, child => {
            // Primitive child should not have children.
            if (!tree.getChildCount(child)) {
                primitives.push(child)
            }
        }, true)
    });

    // Get the center element.
    // TODO: we can get the center of each child boundary, then get the nearest one to the BBox function boundary center.
    if (primitives.length) primitives = [primitives[Math.round((primitives.length - 1) / 2)]];

    let frags = getFragIdFromDbId(primitives);

    if (!frags.length) console.log(`Failed to get the center for IDs:: ${dbIds.join(',')}`);

    return getModifiedWorldBoundingBox(frags, model);
}
export function setPermeativeElementsTheme(dbIds, color) {
    let tree = store.state.viewer?.model?.getInstanceTree();

    if (!tree) return;

    for (let i = 0; i < dbIds.length; i++) {
        // https://aps.autodesk.com/blog/viewer-release-notes-v-65
        setThemingColor(store.state.viewer, dbIds[i], color, null)
    }
}
export function createButton(name, tooltip, classList, tooblar, isVisable, onClick) {
    var button1 = new Autodesk.Viewing.UI.Button(name);
    button1.onClick = function () {
        onClick();
    };
    for (var i = 0; i < classList.length; i++) {
        button1.addClass(classList[i]);
    }
    button1.setToolTip(tooltip);
    tooblar.addControl(button1);
    button1.setVisible(isVisable);

    return button1;
}
//https://gist.github.com/leefsmp/d38f1ce2b81ecf641c72d2b0011bc76c
export function pointerToRaycaster(viewer, pointer) {
    let domElement = viewer.canvas;
    let camera = viewer.impl.camera;
    const pointerVector = new THREE.Vector3()
    const pointerDir = new THREE.Vector3()
    const ray = new THREE.Raycaster()

    const rect = domElement.getBoundingClientRect()

    const x = ((pointer.clientX - rect.left) / rect.width) * 2 - 1
    const y = -((pointer.clientY - rect.top) / rect.height) * 2 + 1

    if (camera.isPerspective) {

        pointerVector.set(x, y, 0.5)

        pointerVector.unproject(camera)

        ray.set(camera.position,
            pointerVector.sub(
                camera.position).normalize())

    } else {

        pointerVector.set(x, y, -1)

        pointerVector.unproject(camera)

        pointerDir.set(0, 0, -1)

        ray.set(pointerVector,
            pointerDir.transformDirection(
                camera.matrixWorld))
    }

    return ray
}
export async function getLeafsObjectsAsync(viewer) {
    if (!viewer) return Promise.reject('Viewer is not defined.');

    return new Promise((resolve, reject) => {
        viewer.model.getObjectTree(function (instanceTree) {
            let promises = [];

            instanceTree.enumNodeChildren(instanceTree.getRootId(), function (dbId) {
                if (instanceTree.getChildCount(dbId) === 0) {                                        
                    let bBox = [];
                    instanceTree.getNodeBox(dbId, bBox);
                    let x = (bBox[0] + bBox[3]) / 2;
                    let y = (bBox[1] + bBox[4]) / 2;
                    let z = (bBox[2] + bBox[5]) / 2;

                    let o = new ForgeObject();
                    o.dbId = dbId;
                    o.name = instanceTree.getNodeName(dbId);
                    o.center = new THREE.Vector3(x, y, z).add(viewer.model.getGlobalOffset());

                    promises.push(Promise.resolve(o));
                }
            }, true);

            Promise.all(promises).then((objects) => {
                resolve(objects);
            }).catch((error) => {
                reject(error);
            });
        });        
    })
}
export function getAllLeafComponents(model, callback) {
    model.getObjectTree(function (tree) {
        let promises = [];

        tree.enumNodeChildren(tree.getRootId(), function (dbId) {
            if (tree.getChildCount(dbId) === 0) {
                let promise = new Promise((resolve) => {
                    resolve(dbId);
                });
                promises.push(promise);    
            }
        }, true);

        Promise.all(promises).then((dbIds) => {
            callback(dbIds);
        }).catch((error) => {
            console.error(error);
        });
    });
}
export function zoomToFit(viewer, dbIds, model, enableAnimation = true) {
    if (!viewer) return;

    let preferences = viewer.getSettingsPanel()?.preferences;

    if (!preferences) return;

    let currentMode = preferences.get("selectionMode");
    if (currentMode != Autodesk.Viewing.SelectionMode.LEAF_OBJECT) {
        setSelectionMode(viewer, Autodesk.Viewing.SelectionMode.LEAF_OBJECT)
    }

    viewer.select(dbIds, model);
    viewer.utilities.fitToView(!enableAnimation);
    viewer.clearSelection();

    if (currentMode != preferences.get("selectionMode")) {
        setSelectionMode(viewer, currentMode)
    }
}
export function setSelectionMode(viewer, mode) {
    if (!viewer) return;

    viewer.getSettingsPanel()?.controls['ViewerSettingsPanel0-0-adsk_settings_control_id_22']?.listeners?.change[0]?.callbackFn({
        detail: {
            value: mode
        }
    })
}
export function takeScreenshotForDbids(viewer, dbids, callback, isolate = true) {
    var state = viewer.getState();
    viewer.setGhosting(false);
    zoomToFit(viewer, dbids, viewer.model, false);

    if (isolate) {
        viewer.clearSelection();
        viewer.isolate(dbids, viewer.model, false);
    } else {
        viewer.select(dbids)
    }

    store.state.forgeService.cameraZoomOutByScaler(0.25);

    setTimeout(() => {
        takeScreenshot(viewer, base64 => {
            viewer.restoreState(state);
            if (callback) callback(base64);
        })
    }, 100);
}
export function takeScreenshotForDbidsNoRestore(viewer, dbids, callback) {

    if (!Array.isArray(dbids)) dbids = [dbids];

    viewer.setGhosting(false);
    zoomToFit(viewer, dbids, viewer.model, false);

    viewer.clearSelection();
    viewer.isolate(dbids, viewer.model, false);

    setTimeout(() => {
        takeScreenshot(viewer, base64 => {
            if (callback) callback(base64);
        })
    }, 100);
}
export function take3dScaffoldScreenshot(scaffold, callback) {
    let viewer = store.state.viewer;

    var state = viewer.getState();

    let box = scaffold.getBox();
    viewer.navigation.fitBounds(true, box);

    setTimeout(() => {
        takeScreenshot(viewer, base64 => {
            viewer.restoreState(state);
            if (callback) callback(base64);
        })
    }, 100);
}
export function takeScreenshot2DAroundPoint(viewer, point, callback) {
    var state = viewer.getState();
    var min = new THREE.Vector3(point.x - .01, point.y - .01, point.z - .01);
    var max = new THREE.Vector3(point.x + .01, point.y + .01, point.z + .01);
    var box = new THREE.Box3(min, max);
    viewer.navigation.fitBounds(true, box);
    setTimeout(() => {
        takeScreenshot(viewer, base64 => {
            callback(base64);
            viewer.restoreState(state);
        })
    }, 100);
}
export function getForgeToken(callback) {
    HttpService.get({
        url: 'forge/oauth/token',
    }).then(response => {
        callback(response.data.access_token, response.data.expires_in);
    })
}
export function setModelVisibility(viewer, model, isVisible) {
    if (!isVisible)
        model.setAllVisibility(0);
    else
        model.setAllVisibility(1);
    viewer.impl.toggleGhosting(false);
    viewer.impl.invalidate(true, true, true);
}
export function setModelTransparency(model, opacity) {
    let modelMaterials = [];
    let viewerMaterials = store.state.viewer.impl.getMaterials()._materials;
    for (let key of Object.keys(viewerMaterials)) {
        if (key == '__fadeMaterial__')
            continue;
        // if(key.startsWith(`model:${model.id}`))
        modelMaterials.push(viewerMaterials[key]);
    }
    modelMaterials.forEach(material => {
        material.opacity = opacity
        material.transparent = true
        material.needsUpdate = true
    });
    //model.unconsolidate();

    store.state.viewer.impl.invalidate(true, true, true);
}

//https://stackoverflow.com/questions/70152847/how-to-add-custom-material-to-a-fragment-in-forge-viewer
export function createMaterial(viewer, materialName, color, isTransparent) {
    var material = viewer.impl.getMaterials()._materials[materialName];
    if (material)
        return material;

    material = new THREE.MeshPhongMaterial({
        side: THREE.DoubleSide,
        reflectivity: 0,
        color: new THREE.Color(color),
        transparent: isTransparent,
    });
    const materials = viewer.impl.matman();
    materials.addMaterial(materialName, material, true);
    return material;
}

export function createGrayMaterial(viewer, materialName) {
    var material = viewer.impl.getMaterials()._materials[materialName];

    if (material) return material;

    let grayColor = new THREE.Color(0.75, 0.75, 0.75);

    material = new THREE.MeshPhongMaterial({
        side: THREE.DoubleSide,
        reflectivity: 0,
        shininess: 100,
        color: grayColor,
        emissive: new THREE.Color(0, 0, 0),
        transparent: true,
    });
    const materials = viewer.impl.matman();
    materials.addMaterial(materialName, material, true);
    return material;
}

export function applyMaterial(model, dbid, material) {
    const tree = model.getInstanceTree();
    const frags = model.getFragmentList();
    tree.enumNodeFragments(
        dbid,
        (fragid) => frags.setMaterial(fragid, material),
        true
    );
}
export function getAlldbIds(instanceTree) {
    var rootId = instanceTree.getRootId();
    var alldbId = [];
    if (!rootId) {
        return alldbId;
    }
    var queue = [];
    queue.push(rootId);
    while (queue.length > 0) {
        var node = queue.shift();
        alldbId.push(node);
        instanceTree.enumNodeChildren(node, function (childrenIds) {
            queue.push(childrenIds);
        });
    }
    return alldbId;
}

export function checkIsModelTrasnlated(urn, callback) {
    getForgeToken(function (access_token) {
        HttpService.get({
            baseURL: `https://developer.api.autodesk.com/modelderivative/v2/designdata/${urn}/manifest`,
            headers: { 'Authorization': 'Bearer ' + access_token },
        }).then(response => {
            if (response.data.status === 'success') {
                callback(true);
            } else {
                callback(response.data.progress)
            }
        }).catch(error => {
            console.log(error)
            callback(false);
        });
    })
}

export function monitorTranslationStatus(urn) {
    return new Promise((resolve, reject) => {
        let failureCount = 0;
        const maxFailures = 10;

        function checkStatus() {
            checkIsModelTrasnlated(urn, function (status) {
                if (status === true) {
                    resolve(true);
                } else if (status === false) {
                    failureCount++;
                    console.log(`Model translation failed. Attempt ${failureCount} of ${maxFailures}`)
                    if (failureCount < maxFailures) {
                        setTimeout(checkStatus, 10000);
                    } else {
                        reject(new Error("Maximum number of failures reached.")); 
                    }
                } else {
                    store.dispatch({
                        type: "showSuccessfulMessage",
                        message: `Translation progress: ${status}`
                    });
                    setTimeout(checkStatus, 10000); 
                }
            });
        }
        checkStatus();
    });
}

export async function addViewable(viewer, urn, xform, offset) {
    return new Promise(function (resolve, reject) {
        function onDocumentLoadSuccess(doc) {
            const viewable = doc.getRoot().getDefaultGeometry();
            const options = {
                preserveView: true,
                keepCurrentModels: true,
                applyScaling: { to: store.getters["getDisplayUnit"] },
            };
            if (xform) {
                options.placementTransform = xform;
            }
            if (offset) {
                options.globalOffset = offset;
            }
            viewer.loadDocumentNode(doc, viewable, options)
                .then(resolve)
                .catch(reject);
        }
        function onDocumentLoadFailure(code) {
            reject(`Could not load document (${code}).`);
        }
        Autodesk.Viewing.Document.load('urn:' + urn, onDocumentLoadSuccess, onDocumentLoadFailure);
    });
}
export function isPointFrontOfCamera(point, forgeViewer) {
    var cameraPosition = forgeViewer.navigation.getPosition();
    var newDirection = forgeViewer.navigation.getCamera().getWorldDirection();
    var direc2D = toPoint2D(newDirection);
    var normalVec = new THREE.Vector2(-direc2D.y, direc2D.x);
    if (isLeft(point, cameraPosition, cameraPosition.clone().add(normalVec)))
        return true;
    return false;
}
export function getVisibleBoundingBox(model) {
    let fragList = model.getFragmentList();
    let fragsCount = fragList.fragments.fragId2dbId.length;
    let fragBox = new THREE.Box3();
    let nodeBox = new THREE.Box3();
    for (let i = 0; i < fragsCount; i++) {
        if (!model.isFragVisible(fragsCount[i]))
            continue;
        fragList.getWorldBounds(fragsCount[i], nodeBox);
        nodeBox.union(fragBox);
    }
    return nodeBox;
}
export function setForgeCropBox(box, viewer) {
    let transform = box && box.transform ? box.transform : null;

    const planes = !box ? null : Autodesk.Viewing.Private.SceneMath.box2CutPlanes(box, transform);
    viewer.impl.setCutPlaneSet('__set_view', planes);
}
export function removeFromScene(meshes, viewer, sceneName) {
    if (!meshes || !viewer || !viewer.impl)
        return;
    if (!(meshes instanceof Array))
        meshes = [meshes];
    meshes.forEach(mesh => {
        if (mesh.geometry)
            mesh.geometry.dispose();
        if (mesh.material)
            mesh.material.dispose();
        let scene = viewer.impl.overlayScenes[sceneName]?.scene;
        scene?.remove(mesh);
    })
}
export function addToScene(obj, viewer, sceneName) {
    if (!viewer.overlays.hasScene(sceneName))
        viewer.overlays.addScene(sceneName);
    viewer.overlays.addMesh(obj, sceneName);
}
export function distanceToPointToRelativeDistance(point) {
    return store.state.viewer.navigation.getPosition().distanceTo(point) / 110;
}
export function getURNThumbnail(urn, callback) {
    HttpService.get({
        url: `api/forge/getURNThmbnail?urn=${urn}`,
    }).then(response => {
        callback(response.data);
    }).catch(error => {
        console.log(error)
    })
}
//https://forge.autodesk.com/blog/how-do-you-add-labels-forge-viewer
export function createTextGl(text, size, color, center, viewer, sceneName) {
    let geom = new THREE.TextGeometry(text, {
        font: "artifakt element",
        size: size,
        height: 0,
        curveSegments: 3,
    });

    //Here we compute it's boundingbox
    geom.computeBoundingBox();
    //Here we define the material for the geometry
    var mat = new THREE.MeshBasicMaterial({ color: color });

    //Here we create the mesh from using the geometry and material
    let mesh = new THREE.Mesh(geom, mat);

    //Then, we set its position
    var width = geom.boundingBox.max.x - geom.boundingBox.min.x
    var height = geom.boundingBox.max.y - geom.boundingBox.min.y
    mesh.position.x = center.x - .5 * width;
    mesh.position.y = center.y - .5 * height;
    mesh.position.z = center.z;

    //Now we just need to add on a custom scene on viewer
    addToScene(mesh, viewer, sceneName);
    return mesh;
}
export function rotateViewerCamera(viewer, angle) {
    var nav = viewer.navigation;
    var cam = nav.getCamera();
    var upVector = cam?.up;
    var rotationMatrix = new THREE.Matrix4();
    rotationMatrix = rotationMatrix.makeRotationZ(angle);
    upVector.applyMatrix4(rotationMatrix);
    nav.setCameraUpVector(upVector, true);
}

export function rotateViewerMarkups(autodeskMarkupsExtension, angle) {
    var rotationMatrix = new THREE.Matrix4()
    rotationMatrix = rotationMatrix.makeRotationZ(-angle);
    autodeskMarkupsExtension.markups.forEach(m => {
        var position = Object.assign(new THREE.Vector3, m.position);
        position.applyMatrix4(rotationMatrix);
        m.setPosition(position.x, position.y);
        m.setRotation(m.getRotation() + angle);
    })
}

export function unloadViewerAllModels(viewer) {
    var models = viewer.getAllModels();
    if (viewer.model) {
        for (let i = 0; i < models.length; i++) {
            viewer.unloadModel(models[i]);
        }
    }
}

export function getViewerCurrentPdfPagesCount(viewer) {
    var pagesCount = viewer?.model?.getDocumentNode()?.getRootNode()?.children.length;
    return pagesCount;
}
export function getAllParentsIds(viewer, dbId) {
    let rootId = viewer?.model?.getDocumentNode()?.getRootNode()?.id ?? 0;
    let maxDepth = 50; // To prevent infinite recursion.
    let depth = 0;
    let currentId = dbId;
    let parents = [];

    while (currentId > rootId && depth < maxDepth) {
        depth++;
        currentId = getNodeParentId(viewer, currentId);
        parents.push(currentId);
    }

    return parents;
}
export function getNodeParentId(viewer, id) {
    return viewer?.model?.getInstanceTree()?.getNodeParentId(id);
}
export function getAllDbIds(viewer) {
    var instanceTree = viewer.model.getData().instanceTree;
    var allDbIdsStr = Object.keys(instanceTree.nodeAccess.dbIdToIndex);
    return allDbIdsStr.map(function (id) { return parseInt(id); });
}
export function processGetChunkProperties(viewer, chunk) {
    return new Promise((resolve, reject) => {
        let properties = [];
        let categories = {};
        try {
            viewer.model.getBulkProperties(chunk, null, function (result) {
                result.forEach(item => {
                    let modelProperties = item.properties;
                    for (let i = 0; i < modelProperties.length; i++) {
                        const { displayName, displayCategory } = modelProperties[i];
            
                        if (!!displayCategory && displayCategory.startsWith("__")) continue;
            
                        if (!categories[displayCategory]) categories[displayCategory] = [];
            
                        if (!categories[displayCategory].includes(displayName)) categories[displayCategory].push(displayName);
            
                        if (!properties.includes(displayName)) properties.push(displayName);                
                    }
                });                
                resolve({categories, properties});
            }, reject);
        } catch (error) {
            reject(error);
        }        
    })
}
export function getAllModelProperties(viewer, callback) {
    console.log('🔎 Loading all properties...')
    let allDbIds = getAllDbIds(viewer);
    let loaded_properties = [];
    let loaded_categories = {};
    let chunkSize = 1000;
    let promises = [];

    for (var i = 0; i < allDbIds.length; i += chunkSize) {
        var chunk = allDbIds.slice(i, i + chunkSize);
        promises.push(processGetChunkProperties(viewer, chunk));
    }

    Promise.allSettled(promises).then((e) => {
        e.filter(t => t.status === 'fulfilled')
        .forEach((result) => {
            let { properties, categories } = result.value;
            properties.forEach(property => {
                if (!loaded_properties.includes(property)) loaded_properties.push(property);
            });

            Object.keys(categories).forEach(category => {
                if (!loaded_categories[category]) loaded_categories[category] = [];
                categories[category].forEach(property => {
                    if (!loaded_categories[category].includes(property)) loaded_categories[category].push(property);
                });
            });
        });
        
        console.log(`✅ Total properties loaded: ${loaded_properties.length}`);

        setTimeout(() => {
            if (callback) callback({ properties: loaded_properties, categories: loaded_categories });
        }, 0);
    });
}
export function getAllModelProperties2(viewer, callback) {
    const instanceTree = viewer.model.getInstanceTree();
    let properties = [];
    let categories = {};
    let count = 0;
    try {
        instanceTree.enumNodeChildren(instanceTree.getRootId(), (id) => {
            viewer.getProperties(id, (forgeEle) => {
                for (let i = 0; i < forgeEle.properties.length; i++) {
                    const { displayName, displayCategory } = forgeEle.properties[i];

                    if (!!displayCategory && displayCategory.startsWith("__")) continue;

                    if (!categories[displayCategory]) categories[displayCategory] = [];

                    if (!categories[displayCategory].includes(displayName)) categories[displayCategory].push(displayName);

                    if (!properties.includes(displayName)) properties.push(displayName);
                }
            });
            count++;
            if (count >= 500000 || count >= instanceTree.nodeAccess.numNodes) {
                throw `💥 Too many nodes to get properties, aborting, count: ${instanceTree.nodeAccess.numNodes}`;
            }
        }, true)
    } catch (e) {
        console.log(e)
    }
    setTimeout(() => {
        if (callback) callback({ properties, categories });
    }, 0);
}
export function getDbIdsProperties(viewer, dbIds) {
    return new Promise((resolve, reject) => {
        try {
            let properties = [];
            for (let i = 0; i < dbIds.length; i++) {
                const dbId = dbIds[i];

                viewer.getProperties(dbId, (result) => {
                    properties.push(...result.properties.filter(t => t.displayName !== 'child' && t.displayName !== 'parent'));
                    if (i == dbIds.length - 1) resolve(properties);
                })
            }
        } catch (error) {
            reject(error);
        }
    })
}
export function getPropertyValues(viewer, property, maxLength, callback) {
    viewer.model.getBulkProperties([], [property], elements => {
        let res = []
        for (let k = 0; k < elements.length; k++) {
            if (maxLength && res.length >= maxLength)
                break;
            if (viewer.model.isNodeExists(elements[k].dbId)) {
                let forgeEle = elements[k]
                var val = forgeEle.properties.find(o => o.displayName == property)
                if (val && !res.includes(val.displayValue))
                    res.push(val.displayValue)
            }
        }
        callback(res)
    })
}
export function getObjectsMatchingProperty(dbids, viewer, property, values, isExactMatch, callback) {
    values = Array.isArray(values) ? values : [values];
    var lowerValues = values.map(value => value.toLowerCase());
    viewer.model.getBulkProperties(dbids, [property], elements => {
        let res = []
        for (let k = 0; k < elements.length; k++) {
            if (viewer.model.isNodeExists(elements[k].dbId)) {
                let forgeEle = elements[k]
                let canAdd = false;
                if (isExactMatch)
                    canAdd = forgeEle.properties.some(o => o.displayName == property && values.includes(o.displayValue))
                else
                    canAdd = forgeEle.properties.some(o => o.displayName == property && !!o.displayValue && lowerValues.some(x => o.displayValue.toLowerCase().includes(x)))
                if (canAdd)
                    res.push(forgeEle);
            }
        }
        callback(res)
    })
}
export function getNodeSortedProperties(viewer, nodeId) {
    if (!viewer) return null;

    return new Promise((resolve, reject) => {
        viewer.getProperties(nodeId, (forgeEle) => {
            const forgeProperties = forgeEle.properties.sort((a, b) =>
                a.displayName.localeCompare(b.name, "en-US", {
                    numeric: "true",
                })
            );

            resolve(forgeProperties);
        }, reject);
    })
}
export function getNodePropertyByName(viewer, nodeId, property) {
    return new Promise((resolve, reject) => {
        viewer.getProperties(nodeId, (forgeEle) => {
            const forgeProperty = forgeEle.properties.find(t => t.displayName === property);
            resolve(forgeProperty);
        }, reject);
    })
}
export function getNodeChildDbids(nodeId, instanceTree) {
    let res = []
    instanceTree.enumNodeChildren(nodeId, (child) => {
        res.push(child)
    })
    return res;
}
export function getNodesAtDepth(rootId, instanceTree, depth) {
    const nodes = [];
    function traverse(nodeId, currentDepth) {
        if (currentDepth === depth) {
            nodes.push(nodeId);
        } else if (currentDepth < depth) {
            let children = getNodeChildDbids(nodeId, instanceTree)
            children.forEach(child => traverse(child, currentDepth + 1));
        }
    }
    traverse(rootId, 0);
    return nodes;
}
export function getNodeChildDbidsForNode(parent, instanceTree) {
    var components = []; // store the results
    if (instanceTree && instanceTree.getChildCount(parent) != 0) {
        instanceTree.enumNodeChildren(parent, function (children) {
            var foundInChilds = getNodeChildDbidsForNode(children, instanceTree);
            components = components.concat(foundInChilds);
        }, false);
    } else {
        components.push(parent);
    }
    return components;
}

/**
* Apply Appearance options to Forge Model.
* @augments forgeUtils.js
*
* @param {Autodesk.Viewing.Viewer3D}       viewer                      Viewer to apply appearacne into.
* @param {Autodesk.Viewing.Model}          model                       Model to apply appearacne into.
* @param {[string]}                        dbIds                       Array of elements dbId to apply appearance to.
* @param {ForgeAppearanceOptions}          options                     Appearance options to be applied.
* @param {string}                          options.colorHexOverride    Color [Hex] override to be applied to elements.
* @param {bool}                            options.isZoomToFit         Zoom to fit selected elements
* @param {bool}                            options.clear               Clears all previous viewer appearance overrides.
* @param {ForgeVisiblityMode}              options.forgeVisiblityMode  VisibilityMode.
* @param {Autodesk.Viewing.SelectionMode}  options.selectionMode       SelectionMode.
* @param {Autodesk.Viewing.SelectionType}  options.selectionType       SelectionType.
* @return {bool} Returns true if excuted successfully, otherwise returns false.
*/
export function applyForgeAppearance(viewer, model, dbIds, options) {
    model = model || viewer.model;
    options = options || new ForgeAppearanceOptions();
    options = Object.assign(new ForgeAppearanceOptions(), options);

    if (options.clear) {
        viewer.showAll();
        clearThemingColors(viewer);
        viewer.clearSelection();
    }

    viewer.setSelectionMode(options.selection);

    var colorHexOverride = options.colorHexOverride;
    if (colorHexOverride != null && colorHexOverride != '') {
        var colorVector4 = options.hexToVector4(colorHexOverride);
        dbIds.map(id => setThemingColor(viewer, id, colorVector4, model))
    }

    viewer.fitToView(dbIds, model, false);
    switch (options.forgeVisiblityMode) {
        case ForgeVisiblityMode.ISOLATE:
            viewer.isolate(dbIds, model);
            return true;

        case ForgeVisiblityMode.SHOW:
            viewer.show(dbIds, model);
            return true;

        case ForgeVisiblityMode.HIDE:
            viewer.hide(dbIds, model);
            return true;

        case ForgeVisiblityMode.SELECT:
            viewer.select(dbIds, model, options.selectionType);
            return true;

        default:
            return false;
    }
}

export function isolateForge(viewer, model, dbIds, fitViewer = true) {
    if (!viewer || !dbIds) return;

    if (fitViewer) {
        if (dbIds.length < 1000) {
            zoomToFit(viewer, dbIds, model);
        } else {
            zoomToFit(viewer, [], model);
        }
    }

    store.state.forgeService.cameraZoomOutByScaler(0.25);

    viewer.isolate(dbIds, model);
}
export function clearThemingColors(viewer) {
    viewer.clearThemingColors(viewer.model);
    store.state.forgeService.dbIdPerThemingColor = {};
}
export function setThemingColor(viewer, dbid, color, model) {
    viewer.setThemingColor(dbid, color, model, true)
    store.state.forgeService.dbIdPerThemingColor[dbid] = color;
}

export function scrollToElementInContainer(element, selector) {
    if (!element) return;
    let parentDiv = element.closest(selector);
    if (!parentDiv) return;
    const parentTop = parentDiv.offsetTop;
    const specificTop = element.offsetTop;
    const distance = specificTop - parentTop;
    parentDiv.scrollTop = distance;
}

export function convertToMonthNameDate(d) {
    const date = new Date(d);

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    const formattedDate = `${day}-${months[monthIndex]}-${year}`;

    return formattedDate;
}

export function waitForValue(valueToCheck, maxTime) {
    return new Promise((resolve, reject) => {
        let timeElapsed = 0;
        const intervalId = setInterval(() => {
            if (valueToCheck()) {
                resolve();
                clearInterval(intervalId);
            } else {
                timeElapsed += 500;
                if (timeElapsed >= maxTime) {
                    reject("Timeout");
                    clearInterval(intervalId);
                }
            }
        }, 500);
    })
}